import React from 'react'
import styles from './index.module.scss'

interface IProps {
  disabled?: boolean
  fixed?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  children?: React.ReactNode
}
export default function Button(props: IProps) {
  const { disabled = false, fixed = false, children, onClick } = props

  const handleClick = (event) => {
    if(disabled) return
    onClick && onClick(event)
  }
  return (
    <div className={[styles.btnContainer, fixed ? styles.fixed : ''].join(' ')}>
      <button
        className={[styles.btn, disabled ? styles.disabled : ''].join(' ')}
        onClick={handleClick}
      >
        {children}
      </button>
    </div>
  )
}
